// [FROST BUDDY] Free-shipping "add an accessory" nudge helper.
//
// Adds two flags to <html> (which is never morphed, so they survive product-section
// hydration), consumed by the block CSS to reveal the nudge link:
//   .fb-has-accessories — the page renders an accessories section (.fb-accessories).
//   .fb-atc-used        — the shopper used THIS page's add-to-cart button this pageview AND the
//                         resulting cart update has recalculated the free-ship bar. A click on
//                         this page's add-to-cart button sets a pending intent; the flag is only
//                         added once the ensuing cart-lines-update promise resolves (so the new
//                         "$X from free shipping" amount lands first, then the nudge appears).
//                         Not set from the cart already having items, nor from other cart updates.
// The nudge-link click is delegated on document; it scrolls to the accessories section.

import { StandardEvents } from '@shopify/events';

/* ── Accessories presence flag ── */
function addIfPresent() {
  if (document.querySelector('.fb-accessories')) {
    document.documentElement.classList.add('fb-has-accessories');
  }
}
function removeIfAbsent() {
  if (!document.querySelector('.fb-accessories')) {
    document.documentElement.classList.remove('fb-has-accessories');
  }
}

addIfPresent();
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addIfPresent);
window.addEventListener('load', addIfPresent);
document.addEventListener('shopify:section:load', addIfPresent);
document.addEventListener('shopify:section:unload', removeIfAbsent);

/* ── Reveal the nudge only after this page's ATC add recalculates the free-ship bar ── */
let atcPending = false;

// This page's add-to-cart button (main or sticky) sets intent; the accessory-row +Add buttons
// are `.fb-acc-add` (no name="add"), so they don't count.
document.addEventListener('click', (event) => {
  if (event.target.closest('.add-to-cart-button, button[name="add"]')) {
    atcPending = true;
  }
});

// The cart-lines-update event carries a promise that resolves with the new cart — the same one
// the free-shipping component uses to recompute the remaining amount. Wait for it (then a frame,
// so the recalculated amount paints first), and only then reveal the nudge.
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (!atcPending) return;
  atcPending = false;
  const reveal = () => requestAnimationFrame(() => document.documentElement.classList.add('fb-atc-used'));
  if (event.promise && typeof event.promise.then === 'function') {
    event.promise.then(reveal, reveal);
  } else {
    reveal();
  }
});

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-fb-accessories-link]');
  if (!link) return;
  const accessories = document.querySelector('.fb-accessories');
  if (!accessories) return;
  event.preventDefault();
  (accessories.closest('.shopify-section') || accessories).scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
});
